import { render, staticRenderFns } from "./CustomText.vue?vue&type=template&id=28134b77&scoped=true&"
import script from "./CustomText.vue?vue&type=script&lang=js&"
export * from "./CustomText.vue?vue&type=script&lang=js&"
import style0 from "./CustomText.vue?vue&type=style&index=0&id=28134b77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28134b77",
  null
  
)

export default component.exports